import { ofType } from 'redux-observable';
import { from, Observable } from 'rxjs';
import {
    OLDplayersReportPageableSuccess,
    playersReportGrandTotalSuccess,
    playersReportPageableSuccess,
    PlayersReportTypes,
} from '../../actions/backoffice/players-report-actions';
import { catchError, map, mergeMap } from 'rxjs/operators';
import {
    currencyUtils,
    dateFormatter,
    getLoginRequestHeader,
    localStorageHelper,
} from '../../../utils';
import { of } from 'rxjs';
import { IAction, IStateObservable } from '../../../helpers/interfaces';
import { apiError } from '../../actions/user-actions';
import axios from 'axios';
import { SERVER_URL } from '../../../utils/config';

export const playersReportPageableEpic = (action$: Observable<IAction>, state$: IStateObservable) =>
    action$.pipe(
        ofType(PlayersReportTypes.PLAYERS_REPORT_REQUEST),
        mergeMap((action) => {
            const { fromDate, toDate, tableParams } = action.payload;
            const { pagination, sortOrder, sortField } = tableParams;

            const requestBody = {
                roundTypes: action.payload.roundTypes,
                includeTestPlayers:
                    localStorageHelper.getChainedValue('user.preferences.displayTestData') ||
                    state$.value.userReducer.shouldDisplayTestData,
                playerCurrencyIds: currencyUtils.getSelectedCurrenciesIdsData(),
                start: dateFormatter.getFormattedStartDate(fromDate),
                end: dateFormatter.getFormattedEndDate(toDate),
                currencyBreakdown: localStorageHelper.getChainedValue(
                    'user.reports.filters.currenciesBreakdown',
                )
                    ? 'currency'
                    : 'none',
                currentPage: pagination.current,
                pageSize: pagination.pageSize,
                sortOrder: sortOrder === 'ascend' ? 'ASCENDING' : 'DESCENDING',
                sortBy: sortField,
            };

            const headers = getLoginRequestHeader();

            return from(
                axios.post(
                    `${SERVER_URL}/reports/revenue/by-player-with-round-types/pageable`,
                    requestBody,
                    {
                        headers,
                    },
                ),
            ).pipe(
                map((response) => {
                    const pageableData = response.data;
                    return playersReportPageableSuccess({ pageableData });
                }),
                catchError((error) =>
                    of(apiError(error, PlayersReportTypes.PLAYERS_REPORT_REQUEST)),
                ),
            );
        }),
    );

//OLD
export const OLDplayersReportPageableEpic = (
    action$: Observable<IAction>,
    state$: IStateObservable,
) =>
    action$.pipe(
        ofType(PlayersReportTypes.OLD_PLAYERS_REPORT_REQUEST),
        mergeMap((action) => {
            const { fromDate, toDate, tableParams } = action.payload;
            const { pagination, sortOrder, sortField } = tableParams;

            const requestBody = {
                includeTestPlayers:
                    localStorageHelper.getChainedValue('user.preferences.displayTestData') ||
                    state$.value.userReducer.shouldDisplayTestData,
                playerCurrencyIds: currencyUtils.getSelectedCurrenciesIdsData(),
                start: dateFormatter.getFormattedStartDate(fromDate),
                end: dateFormatter.getFormattedEndDate(toDate),
                currencyBreakdown: localStorageHelper.getChainedValue(
                    'user.reports.filters.currenciesBreakdown',
                )
                    ? 'currency'
                    : 'none',
                currentPage: pagination.current,
                pageSize: pagination.pageSize,
                sortOrder: sortOrder === 'ascend' ? 'ASCENDING' : 'DESCENDING',
                sortBy: sortField,
            };

            const headers = getLoginRequestHeader();

            return from(
                axios.post(`${SERVER_URL}/reports/revenue/by-player/pageable`, requestBody, {
                    headers,
                }),
            ).pipe(
                map((response) => {
                    const pageableData = response.data;
                    return OLDplayersReportPageableSuccess({ pageableData });
                }),
                catchError((error) =>
                    of(apiError(error, PlayersReportTypes.OLD_PLAYERS_REPORT_REQUEST)),
                ),
            );
        }),
    );

//OLD
export const playersReportGrandTotalEpic = (
    action$: Observable<IAction>,
    state$: IStateObservable,
) =>
    action$.pipe(
        ofType(PlayersReportTypes.PLAYERS_REPORT_TOTAL_REQUEST),
        mergeMap((action) => {
            const { fromDate, toDate } = action.payload;

            const requestBody = {
                includeTestPlayers:
                    localStorageHelper.getChainedValue('user.preferences.displayTestData') ||
                    state$.value.userReducer.shouldDisplayTestData,
                playerCurrencyIds: currencyUtils.getSelectedCurrenciesIdsData(),
                start: dateFormatter.getFormattedStartDate(fromDate),
                end: dateFormatter.getFormattedEndDate(toDate),
                currencyBreakdown: localStorageHelper.getChainedValue(
                    'user.reports.filters.currenciesBreakdown',
                )
                    ? 'currency'
                    : 'none',
            };

            const headers = getLoginRequestHeader();

            return from(
                axios.post(`${SERVER_URL}/reports/revenue/by-player/grand-total`, requestBody, {
                    headers,
                }),
            ).pipe(
                map((response) => {
                    const grandTotalData = response.data;
                    return playersReportGrandTotalSuccess({ grandTotalData });
                }),
                catchError((error) =>
                    of(apiError(error, PlayersReportTypes.PLAYERS_REPORT_TOTAL_REQUEST)),
                ),
            );
        }),
    );
